var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
import USERS from 'apollo/queries/USERS';
// TEAM_UPDATE_USERS
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamUpdateUsers($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateUsers(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"], ["\n  mutation TeamUpdateUsers($add_ids: [ID!], $team_id: ID!, $remove_ids: [ID!]) {\n    teamUpdateUsers(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"])));
export default function useTeamUpdateUsersMutation(variables) {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamUpdateUsers',
        successMessage: 'Team users updated',
        refetchQueries: [{ query: USERS, variables: variables }]
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
